module.exports = __webpack_public_path__ + "img/credit_visa_electron_icon.a016a8d3.png";